module.exports = __webpack_public_path__ + "imgcvh/hero-5.d09a2bd9.jpg";